import styled from 'styled-components'
import { parseRem } from 'styles'

interface Props {
  maxWidth?: number | string
}

export const SearchForm = styled.form<Props>`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: ${(props) =>
    typeof props.maxWidth === 'number'
      ? parseRem(props.maxWidth)
      : props.maxWidth};

  h6 {
    white-space: nowrap;
  }

  > * {
    &:nth-child(1) {
      width: 100%;
    }
  }
`
